import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const WhatsAppButton: React.FC = () => {
  return (
    <a
      href="https://wa.me/919024978540"
      className="whatsapp-floating-btn"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact us on WhatsApp"
    >
      {/* Bypass React 19 JSX typings by calling the function component directly */}
      {FaWhatsapp({ size: 34, color: '#ffffff' }) as any}
    </a>
  );
};

export default WhatsAppButton;
